import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRightLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowRightLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M16.2501 2.18945L21.3108 7.25011L16.2501 12.3108L15.1895 11.2501L18.4395 8.00011H3.00011V6.50011H18.4395L15.1895 3.25011L16.2501 2.18945ZM8.81077 12.7501L5.56077 16.0001H21.0001V17.5001H5.56077L8.81077 20.7501L7.75011 21.8108L2.68945 16.7501L7.75011 11.6895L8.81077 12.7501Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRightLeft;
